import {
  SENDING_REQUEST,
  CREATE_SUCCESS,
  FAILURE,
  UPDATE_SUCCESS,
  RESET_FORM,
  VALUE_CHANGED,
} from './_constants';

const initialState = {
  isLoading: false,
  record: {},
};

export const projectsForm = (state = initialState, action) => {
  switch (action.type) {
    
    case VALUE_CHANGED:
      return {
        ...state,
        record: {
          ...state.record,
          [action.data.name]: action.data.value,
        }
      }

    case RESET_FORM:
      return {
        ...initialState,
      };

    case SENDING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case CREATE_SUCCESS:
    case UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        record: action.record,
      };

    case FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    default:
      return state;
  }
}